const ACCESS_TOKEN_KEY = 'stratagen_access_token';

export function setStoredAccessToken(token: string): void {
  sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function getStoredAccessToken(): string | null {
  return sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

export function clearStoredAccessToken(): void {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function hasStoredAccessToken(): boolean {
  return Boolean(getStoredAccessToken());
}

/**
 * Auth0 Lock (login page) and Auth0Provider (SPA SDK) use different sessions.
 * Prefer the Lock token stored at login; fall back to silent SDK auth when available.
 */
export async function getAccessToken(
  getAccessTokenSilently: () => Promise<string>
): Promise<string> {
  const stored = getStoredAccessToken();
  if (stored) return stored;
  return getAccessTokenSilently();
}
